export const projectModuleActionTypes = {

    GET_ALL_DEEP_CLEAN_CHART :'GET_ALL_DEEP_CLEAN_CHART',
    GET_ALL_DEEP_CLEAN_CHART_PENDING: 'GET_ALL_DEEP_CLEAN_CHART_PENDING',
    GET_ALL_DEEP_CLEAN_CHART_FULFILLED: "GET_ALL_DEEP_CLEAN_CHART_FULFILLED",

    DEEP_CLEAN_CHART_PAGE_CLICKED : 'DEEP_CLEAN_CHART_PAGE_CLICKED'
}